import { get } from 'api/get';
import { post } from 'api/post';
import { buildErrorPayload } from 'state/buildErrorPayload';
import { appendStatus } from 'state/status/actions';

import _ from 'lodash';

export const LOGIN_REQUEST = 'auth/login/request';
export const LOGIN_SUCCESS = 'auth/login/success';
export const LOGIN_FAILURE = 'auth/login/failure';

export const LOGOUT_SUCCESS = 'auth/logout/success';
export const LOGOUT_FAILURE = 'auth/logout/failure';

export const TEMP_PASSWORD_CHANGE_SUCCESS = 'auth/temp-pw/change';

export const AUTH_GET_REQUEST = 'auth/get/request';
export const AUTH_GET_SUCCESS = 'auth/get/success';
export const AUTH_GET_FAILURE = 'auth/get/failure';

export const CHECK_IP_SUCCESS = 'auth/check-ip/success';
export const CHECK_IP_FAILURE = 'auth/check-ip/failure';

export const CLEAR_SESSION = 'auth/clear-session';

export function getAuth() {

  return async dispatch => {

    dispatch({
      type: AUTH_GET_REQUEST,
      payload: null
    });

    try {
      const req = await get('auth');
      const data = _.get(req, 'data.payload', []);

      const isPerms = _.has(data, 'permissions') === true && Array.isArray(data.permissions) === true && data.permissions.length > 0;
      if ( isPerms === true ) {
        
        dispatch({
          type: AUTH_GET_SUCCESS,
          payload: data
        });  

      } else {
        
        dispatch({
          type: AUTH_GET_FAILURE,
          payload: null
        });
        
        window.location.href = '/login';
      }

      dispatch(checkIfIPIsBanned())
    }
    catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: AUTH_GET_FAILURE,
        payload: null
      });
      
      if (location.pathname !== '/login') {
        window.location.href = '/login?redirect=' + location.pathname;
      } else {
        window.location.href = '/login';
      }

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  }
}

export function login(email, password) {

  return async dispatch => {

    dispatch({
      type: LOGIN_REQUEST,
      payload: null
    });

    try {
      const req = await post('auth/login', {
        email: email,
        password: password
      });

      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: CLEAR_SESSION
      });
      
      dispatch({
        type: LOGIN_SUCCESS,
        payload: data
      });
    }
    catch (error) {

      const errPayload = buildErrorPayload(error);

      dispatch({
        type: LOGIN_FAILURE,
        payload: {
          isValidationError: true
        }
      });
      
      dispatch(checkIfIPIsBanned());

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  }
}

export function logout() {

  return async dispatch => {
    try {
      await post('logout');

      dispatch({
        type: LOGOUT_SUCCESS,
        payload: null
      });
      
      dispatch({
        type: CLEAR_SESSION
      });
      window.location.href = '/login';
    }
    catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: LOGOUT_FAILURE,
        payload: null
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  }
}

export function tempPasswordChanged() {

  return async dispatch => {

    dispatch({
      type: TEMP_PASSWORD_CHANGE_SUCCESS,
      payload: null
    });
  }
}

export function checkIfIPIsBanned() {
  return async dispatch => {
    try {
      
      const req = await get('check-ip');
      const data = _.get(req, 'data.payload', []);

      dispatch({
        type: CHECK_IP_SUCCESS,
        payload: data
      });
    }
    catch (error) {
      const errPayload = buildErrorPayload(error);

      dispatch({
        type: CHECK_IP_FAILURE,
        payload: null
      });

      dispatch(appendStatus(errPayload.errorMessage, 'error'));
    }
  }
}
